<app-tools-jumbotron
  [latestUpdate]="latestUpdate"
  [pageInfo]="pageInfo()"
></app-tools-jumbotron>

<div class="jumbotron pt-7 bg-white">
  <div class="container mx-auto">
    <div class="post__details p-4 md:p-6">
      <div [innerHTML]="safeHtml()"></div>
      <section class="mt-12 border-t pt-6">
        <h3
          class="text-xl font-semibold text-gray-900 mb-3"
          translate="Discover More Free Posty5 Solutions"
        ></h3>
        <p
          class="text-lg leading-relaxed text-gray-700 mb-2"
          translate="Enhance your online presence with Posty5's suite of free and efficient tools:"
        ></p>
        <div
          class="container mx-auto sm:px-0 px-4 mt-5 grid grid-cols-1 md:grid-cols-2 gap-4 mb-3"
        >
          @for (blog of blogList(); track $index) {
            <app-card [blog]="blog"></app-card>
          }
        </div>
      </section>
    </div>
  </div>
</div>
